import apiClient from './apiClient';

const companyAPI = {
  getAllCompanies: () => apiClient.get('/company/index'),
  getCompanyTypes: () => apiClient.get('/company/company-type'),
  createCompany: (companyData) => apiClient.post('/company/store', companyData),
  deleteCompany: (companyId) => apiClient.delete(`/company/delete/${companyId}`),
  updateCompany: (id, companyData) => apiClient.post(`/company/update/${id}`, companyData),
  singleCompany: (companyId) => apiClient.get(`/company/show/${companyId}`)
};

export default companyAPI;
